import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-sm-12 text-left">
            <h3>LINKS</h3>
            <ul>
              <li>
                <a
                  href="http://www.reddwarf.co.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  The Official <em>Red Dwarf</em> Website
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-6 text-right mt-3">
            <div className="text-right">
              &copy; {year} Grant Naylor Productions.
              <br />
              All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx